export const TQ = {};

//-------------------------------------------------------------------
TQ.UPDATE_PENDING_LIST = "UPDATE_PENDING_LIST";

//-------------------------------------------------------------------
TQ.UPDATE_TOTAL_LIST = "UPDATE_TOTAL_LIST";
//-------------------------------------------------------------------
